import { fundPage } from '@/content/engagement';

export function FundModel() {
  return (
    <section
      aria-labelledby="fund-model-heading"
      className="px-4 py-12 sm:px-6 sm:py-16 lg:px-8"
    >
      <div className="mx-auto w-full max-w-7xl">
        {/* Why + Model (two-column) */}
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] lg:gap-16">
          <div className="space-y-10">
            <div>
              <h2
                id="fund-why-heading"
                className="font-display text-foreground text-2xl font-semibold tracking-tight sm:text-3xl"
              >
                {fundPage.whyHeading}
              </h2>
              <div className="mt-4 space-y-4">
                {fundPage.whyBody.map((paragraph) => (
                  <p key={paragraph} className="text-muted-foreground text-base leading-relaxed sm:text-lg">
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>

            <div>
              <h2
                id="fund-model-heading"
                className="font-display text-foreground text-2xl font-semibold tracking-tight sm:text-3xl"
              >
                {fundPage.modelHeading}
              </h2>
              <div className="mt-4 space-y-4">
                {fundPage.modelBody.map((paragraph) => (
                  <p key={paragraph} className="text-muted-foreground text-base leading-relaxed sm:text-lg">
                    {paragraph}
                  </p>
                ))}
              </div>
            </div>
          </div>

          <div className="space-y-4">
            {fundPage.modelPoints.map((point) => (
              <article
                key={point.title}
                className="border-border/70 bg-card/50 rounded-2xl border p-5 shadow-sm backdrop-blur-sm"
              >
                <h3 className="font-display text-foreground text-lg font-semibold tracking-tight">
                  {point.title}
                </h3>
                <p className="text-muted-foreground mt-2 text-sm leading-relaxed">{point.body}</p>
              </article>
            ))}
            <p className="text-muted-foreground border-border/60 border-l-2 pl-4 text-xs leading-relaxed">
              {fundPage.disclaimer}
            </p>
          </div>
        </div>

        {/* What makes this different */}
        <div className="mt-20">
          <h3 className="font-display text-foreground mb-8 text-xl font-semibold tracking-tight sm:text-2xl">
            {fundPage.whatMakesDifferentHeading}
          </h3>
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {fundPage.whatMakesDifferent.map((item) => (
              <article
                key={item.title}
                className="border-border/70 bg-background/60 rounded-2xl border p-6"
              >
                <h4 className="font-display text-foreground text-base font-semibold tracking-tight">
                  {item.title}
                </h4>
                <p className="text-muted-foreground mt-3 text-sm leading-relaxed">{item.body}</p>
              </article>
            ))}
          </div>
        </div>

        {/* Funding priority areas */}
        <div className="mt-20">
          <h3 className="font-display text-foreground mb-8 text-xl font-semibold tracking-tight sm:text-2xl">
            {fundPage.priorityAreasHeading}
          </h3>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {fundPage.priorityAreas.map((area) => (
              <article
                key={area.title}
                className="border-border/70 bg-background/60 rounded-2xl border p-6"
              >
                <h4 className="font-display text-foreground text-base font-semibold tracking-tight">
                  {area.title}
                </h4>
                <p className="text-muted-foreground mt-3 text-sm leading-relaxed">{area.body}</p>
              </article>
            ))}
          </div>
        </div>

        {/* What funding delivers */}
        <div className="mt-20">
          <h3 className="font-display text-foreground mb-8 text-xl font-semibold tracking-tight sm:text-2xl">
            {fundPage.whatFundingDeliversHeading}
          </h3>
          <ul className="grid gap-3 sm:grid-cols-2">
            {fundPage.whatFundingDelivers.map((item) => (
              <li
                key={item}
                className="text-foreground/90 border-border/60 bg-background/40 rounded-xl border px-4 py-4 text-sm leading-relaxed"
              >
                {item}
              </li>
            ))}
          </ul>
        </div>

        {/* Why 5 years */}
        <div className="border-l-primary/60 bg-primary/5 mt-20 border-l-4 rounded-r-xl p-6 sm:p-8">
          <p className="text-foreground text-base leading-relaxed sm:text-lg">
            {fundPage.whyFiveYears}
          </p>
        </div>
      </div>
    </section>
  );
}
